import { useQuery } from '@tanstack/react-query';
import { fetchStations } from '@/api/stations';
import { useAuthStore } from '@/stores/authStore';

export function useStations() {
  const user = useAuthStore((s) => s.user);

  return useQuery({
    queryKey: ['stations', user?.owner],
    queryFn: fetchStations,
    staleTime: 5 * 60 * 1000,
    enabled: !!user,
    select: (data) => ({
      stations: data.stations,
      displayNames: data.stations,
    }),
  });
}
